/**
 * @module SalesFlow/evolved/model/repo
 */

import {ModelEvolvedRepoService} from 'model-evolved/repo/model-evolved--repo--service';

export class ModelEvolvedRepoDiscount extends ModelEvolvedRepoService {

}
